module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "sidebar-under-toolbar": ""
    }
  }, [_c('v-toolbar', [_c('v-toolbar-logo', {
    staticClass: "mr-3 ml-3"
  }, [_c('img', {
    attrs: {
      "src": require("./assets/images/icon_01.png")
    }
  })]), _vm._v(" "), _c('v-toolbar-items', {
    staticClass: "hidden-sm-and-down",
    attrs: {
      "ripple": ""
    }
  }, [(_vm.$router.history.current.name !== 'Hello') ? _c('v-toolbar-item', {
    attrs: {
      "router": "",
      "href": "/"
    }
  }, [_vm._v("首頁")]) : _vm._e(), _vm._v(" "), _c('v-toolbar-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$router.history.current.name === 'Hello'),
      expression: "$router.history.current.name === 'Hello'"
    }],
    nativeOn: {
      "click": function($event) {
        _vm.goAnchor(1)
      }
    }
  }, [_vm._v("功能特色")]), _vm._v(" "), (_vm.$router.history.current.name === 'Hello') ? _c('v-toolbar-item', {
    staticClass: "toolbar--divider"
  }, [_vm._v(" | ")]) : _vm._e(), _vm._v(" "), _c('v-toolbar-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$router.history.current.name === 'Hello'),
      expression: "$router.history.current.name === 'Hello'"
    }],
    nativeOn: {
      "click": function($event) {
        _vm.goAnchor(2)
      }
    }
  }, [_vm._v("熱門景點")]), _vm._v(" "), (_vm.$router.history.current.name === 'Hello') ? _c('v-toolbar-item', {
    staticClass: "toolbar--divider"
  }, [_vm._v(" | ")]) : _vm._e(), _vm._v(" "), _c('v-toolbar-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$router.history.current.name === 'Hello'),
      expression: "$router.history.current.name === 'Hello'"
    }],
    nativeOn: {
      "click": function($event) {
        _vm.goAnchor(3)
      }
    }
  }, [_vm._v("下載方式")]), _vm._v(" "), (_vm.$router.history.current.name === 'Hello') ? _c('v-toolbar-item', {
    staticClass: "toolbar--divider"
  }, [_vm._v(" | ")]) : _vm._e(), _vm._v(" "), _c('v-toolbar-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$router.history.current.name === 'Hello'),
      expression: "$router.history.current.name === 'Hello'"
    }],
    nativeOn: {
      "click": function($event) {
        _vm.goAnchor(4)
      }
    }
  }, [_vm._v("購買方案")]), _vm._v(" "), _c('v-toolbar-item', {
    staticClass: "toolbar--divider"
  }, [_vm._v(" | ")]), _vm._v(" "), _c('v-toolbar-item', {
    attrs: {
      "router": "",
      "href": "/book"
    }
  }, [_vm._v("景點書")]), _vm._v(" "), (!_vm.authorized) ? _c('v-toolbar-item', {
    staticClass: "toolbar--divider"
  }, [_vm._v(" | ")]) : _vm._e(), _vm._v(" "), (!_vm.authorized) ? _c('v-toolbar-item', {
    attrs: {
      "router": "",
      "href": "/login"
    }
  }, [_vm._v("登入")]) : _vm._e(), _vm._v(" "), (!_vm.authorized) ? _c('v-toolbar-item', {
    staticClass: "toolbar--divider"
  }, [_vm._v("|")]) : _vm._e(), _vm._v(" "), (!_vm.authorized) ? _c('v-toolbar-item', {
    attrs: {
      "router": "",
      "href": "/register"
    }
  }, [_vm._v("加入會員")]) : _vm._e(), _vm._v(" "), (_vm.authorized) ? _c('v-toolbar-item', {
    staticClass: "toolbar--divider"
  }, [_vm._v("|")]) : _vm._e(), _vm._v(" "), (_vm.authorized) ? _c('v-toolbar-item', {
    attrs: {
      "router": "",
      "href": "/learning"
    }
  }, [_vm._v("線上學習")]) : _vm._e(), _vm._v(" "), (_vm.authorized) ? _c('v-toolbar-item', {
    staticClass: "toolbar--divider"
  }, [_vm._v("|")]) : _vm._e(), _vm._v(" "), (_vm.authorized) ? _c('v-toolbar-item', {
    attrs: {
      "router": "",
      "href": "/shop"
    }
  }, [_vm._v("金幣兌換")]) : _vm._e(), _vm._v(" "), (_vm.authorized) ? _c('v-toolbar-item', {
    staticClass: "toolbar--divider"
  }, [_vm._v("|")]) : _vm._e(), _vm._v(" "), (_vm.authorized) ? _c('v-toolbar-item', {
    attrs: {
      "router": "",
      "href": "/user"
    }
  }, [_vm._v("控制面板")]) : _vm._e(), _vm._v(" "), (_vm.authorized) ? _c('v-toolbar-item', {
    staticClass: "toolbar--divider"
  }, [_vm._v("|")]) : _vm._e(), _vm._v(" "), (_vm.authorized) ? _c('v-toolbar-item', {
    attrs: {
      "router": "",
      "href": "/logout"
    }
  }, [_vm._v("登出")]) : _vm._e()], 1), _vm._v(" "), _c('v-toolbar-items', {
    staticClass: "hidden-md-and-up"
  }, [_c('v-menu', {
    attrs: {
      "bottom": "",
      "left": "",
      "offset-y": "",
      "origin": "top right",
      "transition": "v-slide-y-transition"
    }
  }, [_c('v-btn', {
    staticClass: "primary-color",
    attrs: {
      "slot": "activator",
      "icon": "",
      "dark": ""
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("more_vert")])], 1), _vm._v(" "), _c('v-list', [_c('v-list-item', [_c('v-list-tile', {
    attrs: {
      "router": "",
      "href": "/"
    }
  }, [_c('v-list-tile-title', {
    domProps: {
      "textContent": _vm._s('首頁')
    }
  })], 1)], 1), _vm._v(" "), _c('v-list-item', [_c('v-list-tile', {
    attrs: {
      "router": "",
      "href": "/book"
    }
  }, [_c('v-list-tile-title', {
    domProps: {
      "textContent": _vm._s('景點書')
    }
  })], 1)], 1), _vm._v(" "), (!_vm.authorized) ? _c('v-list-item', [_c('v-list-tile', {
    attrs: {
      "router": "",
      "href": "/login"
    }
  }, [_c('v-list-tile-title', {
    domProps: {
      "textContent": _vm._s('登入')
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.authorized) ? _c('v-list-item', [_c('v-list-tile', {
    attrs: {
      "router": "",
      "href": "/register"
    }
  }, [_c('v-list-tile-title', {
    domProps: {
      "textContent": _vm._s('加入會員')
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.authorized) ? _c('v-list-item', [_c('v-list-tile', {
    attrs: {
      "router": "",
      "href": "/shop"
    }
  }, [_c('v-list-tile-title', {
    domProps: {
      "textContent": _vm._s('商品兌換')
    }
  })], 1)], 1) : _vm._e()], 1), _vm._v(" "), (_vm.authorized) ? _c('v-list', {
    attrs: {
      "subheader": ""
    }
  }, [_c('v-subheader', {
    staticStyle: {
      "border-bottom": "solid #ccc 1px"
    }
  }, [_vm._v("基本設定")]), _vm._v(" "), _c('v-list-item', [_c('v-list-tile', {
    attrs: {
      "router": "",
      "href": "/user/profile"
    }
  }, [_c('v-list-tile-title', {
    domProps: {
      "textContent": _vm._s('個人資料')
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.authorized) ? _c('v-list', {
    attrs: {
      "subheader": ""
    }
  }, [_c('v-subheader', {
    staticStyle: {
      "border-bottom": "solid #ccc 1px"
    }
  }, [_vm._v("記錄管理")]), _vm._v(" "), _c('v-list-item', [_c('v-list-tile', {
    attrs: {
      "router": "",
      "href": "/user/point"
    }
  }, [_c('v-list-tile-title', {
    domProps: {
      "textContent": _vm._s('我的點數')
    }
  })], 1)], 1), _vm._v(" "), _c('v-list-item', [_c('v-list-tile', {
    attrs: {
      "router": "",
      "href": "/user/coin"
    }
  }, [_c('v-list-tile-title', {
    domProps: {
      "textContent": _vm._s('我的金幣')
    }
  })], 1)], 1), _vm._v(" "), _c('v-list-item', [_c('v-list-tile', {
    attrs: {
      "router": "",
      "href": "/user/attraction"
    }
  }, [_c('v-list-tile-title', {
    domProps: {
      "textContent": _vm._s('我的景點')
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-list', [(_vm.authorized) ? _c('v-list-item', [_c('v-list-tile', {
    attrs: {
      "router": "",
      "href": "/logout"
    }
  }, [_c('v-list-tile-title', {
    domProps: {
      "textContent": _vm._s('登出')
    }
  })], 1)], 1) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), ((_vm.$router.history.current.name !== 'Hello' && _vm.$router.history.current.name !== 'Book')) ? _c('v-breadcrumbs', {
    staticClass: "pt-3",
    staticStyle: {
      "justify-content": "flex-start"
    },
    attrs: {
      "icons": "",
      "divider": "chevron_right"
    }
  }, _vm._l((_vm.breadcrumbs), function(item) {
    return _c('v-breadcrumbs-item', {
      key: item.text,
      attrs: {
        "disabled": item.disabled,
        "target": "_self"
      },
      nativeOn: {
        "click": function($event) {
          _vm.$router.push(item.link)
        }
      }
    }, [_vm._v("\n      " + _vm._s(item.text) + "\n    ")])
  })) : _vm._e(), _vm._v(" "), _c('main', [_c('v-content', {
    class: {
      'pa-5': (_vm.$router.history.current.name !== 'Hello' && _vm.$router.history.current.name !== 'Book')
    }
  }, [_c('v-alert', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.displayMessage),
      expression: "displayMessage"
    }],
    staticClass: "mb-3 pa-3",
    attrs: {
      "error": "",
      "dismissible": ""
    },
    on: {
      "input": _vm.close
    }
  }, [_vm._v("\n        " + _vm._s(_vm.errorMessage) + "\n      ")]), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('router-view')], 1)], 1)], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "pink gotop",
    attrs: {
      "floating": "",
      "small": "",
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.goTop()
      }
    }
  }, [_c('v-icon', [_vm._v("arrow_upward")])], 1)], 1), _vm._v(" "), _c('v-footer', {
    staticClass: "pt-5",
    staticStyle: {
      "height": "auto"
    }
  }, [_c('div', {
    staticClass: "text-sm-center"
  }, [_c('v-container', {
    attrs: {
      "fluid": "fluid"
    }
  }, [_c('v-row', [_c('v-col', {
    staticClass: "service--line",
    attrs: {
      "xs4": "",
      "offset-md2": "",
      "md3": "",
      "offset-lg2": "",
      "lg3": ""
    }
  }), _vm._v(" "), _c('v-col', {
    staticClass: "service--line--center",
    attrs: {
      "xs4": "",
      "md2": "",
      "lg2": ""
    }
  }, [_vm._v("客戶服務")]), _vm._v(" "), _c('v-col', {
    staticClass: "service--line",
    attrs: {
      "xs4": "",
      "md3": "",
      "lg3": ""
    }
  })], 1), _vm._v(" "), _c('v-row', {
    staticClass: "mt-3"
  }, [_c('v-col', {
    attrs: {
      "md12": "",
      "hidden-sm-and-down": ""
    }
  }, [_vm._v("\n            服務電話：(02)2578-7838 | 客服時間：週一至週五 09:00~18:00 | 客服信箱：service@liveabc.com\n          ")]), _vm._v(" "), _c('v-col', {
    attrs: {
      "xs12": "",
      "hidden-md-and-up": ""
    }
  }, [_vm._v("服務電話：(02)2578-7838")]), _vm._v(" "), _c('v-col', {
    attrs: {
      "xs12": "",
      "hidden-md-and-up": ""
    }
  }, [_vm._v("客服時間：週一至週五 09:00~18:00")]), _vm._v(" "), _c('v-col', {
    attrs: {
      "xs12": "",
      "hidden-md-and-up": ""
    }
  }, [_vm._v("客服信箱：service@liveabc.com")])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "xs12": ""
    }
  }, [_vm._v("\n            Copyright@Hebron Soft Limited. All Rights Reserved.\n          ")])], 1)], 1)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c76c6336"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 638
// module chunks = 1